import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getProjectFeatureStatusIndicatorItems = async (projectId) => {
  const apiPath = `projects/${projectId}/feature-status`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    isLocalApiRequest: false,
  });

  const response = await axios(signedRequest);

  return response.data;
};
